"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/call-queues`;
    }
    /**
     * Updates a list of call queues where the user is an agent. This
   * is a full update request, which means that if any call queue where the user is
   * an agent is not mentioned in request, then the user is automatically removed
   * from this queue.
   *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/call-queues
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditCallQueuePresence
     */
    async put(userCallQueues, restRequestConfig) {
        const r = await this.rc.put(this.path(), userCallQueues, undefined, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map